import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { getBrand, pubFromHostname } from "../../lib/brand";
import PublicHeader from "../../components/PublicHeader";
import SiteFooter from "../../components/SiteFooter";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function SubmitterLogin() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [hostPub, setHostPub] = useState(null);

  useEffect(() => {
    getBrand().then((b) => setHostPub(pubFromHostname(b || {})));
  }, []);

  useEffect(() => {
    if (hostPub) document.documentElement.dataset.pub = hostPub;
    return () => { delete document.documentElement.dataset.pub; };
  }, [hostPub]);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Please enter your email.");
    setBusy(true);
    try {
      await api.post("/auth/magic", { email: email.trim(), publication: hostPub || null });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f3ed] flex flex-col" data-testid="submitter-login-page" data-pub={hostPub || "neutral"}>
      <PublicHeader pub={hostPub} />
      <main className="w-full max-w-xl mx-auto px-6 sm:px-10 pt-16 pb-24 flex-1">
        <p className="btw-step-label mb-3">Submissions sign in</p>
        <h1 className="text-3xl sm:text-4xl font-bold leading-tight mb-4">
          Finish off where you left off
        </h1>
        {sent ? (
          <div className="btw-section" data-testid="magic-sent">
            <p className="text-sm text-black leading-relaxed">
              If that email is attached to a submission, a sign-in link is on its way.
              It works once and expires in 30 minutes.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="magic-form">
            <p className="text-sm text-black leading-relaxed mb-10">
              Enter the email you used on your submission and we'll send you a secure
              sign-in link.
            </p>
            <div className="mb-8">
              <label className="text-sm font-bold block mb-1">Email</label>
              <input
                type="email"
                data-testid="magic-email"
                className="btw-input"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
               aria-label="Email"/>
            </div>
            <div className="flex justify-center">
              <button type="submit" disabled={busy} data-testid="magic-submit" className="btw-btn w-full sm:w-auto">
                <span>{busy ? "Sending…" : "Email sign-in link"}</span>
                <span className="btw-btn-arrow"><ArrowRight size={12} /></span>
              </button>
            </div>
          </form>
        )}
        <p className="text-sm text-black mt-16 text-center">
          Starting something new?{" "}
          <a href="/create-event" className="underline underline-offset-4" data-testid="start-new-link">Start a new submission</a>
        </p>
      </main>
      <SiteFooter pub={hostPub} />
    </div>
  );
}
